import { NgModule } from '@angular/core';
import { BetonStoreModule } from './store/beton-store.module';

@NgModule({
  imports: [BetonStoreModule],
})
export class BetonDataAccessModule {}
